import React, { useState } from 'react';
import './Header.css'; // 별도의 스타일 파일을 관리할 수도 있습니다
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 섹션 */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img
                className="h-8 w-auto"
                src="/logo.png"
                alt="시니어랑 로고"
              />
              <span className="ml-2 text-xl font-bold text-gray-800">시니어랑</span>
            </Link>
          </div>

          {/* 네비게이션 메뉴 - 데스크톱 */}
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/education"
              className="text-gray-600 hover:text-orange-500 px-3 py-2 rounded-md text-lg font-bold transition-colors"
            >
              교육 프로그램
            </Link>
            <Link
              to="/community"
              className="text-gray-600 hover:text-orange-500 px-3 py-2 rounded-md text-lg font-bold transition-colors"
            >
              커뮤니티
            </Link>
            <Link
              to="/support"
              className="text-gray-600 hover:text-orange-500 px-3 py-2 rounded-md text-lg font-bold transition-colors"
            >
              고객 지원
            </Link>
          </nav>

          {/* 사용자 섹션 */}
          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/login"
              className="text-gray-400 hover:text-orange-400 px- py-2 rounded-md text-sm font-medium transition-colors"
            >
              로그인
            </Link>
            <Link
              to="/join"
              className="text-gray-400 hover:text-orange-400 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              회원가입
            </Link>
            <Link
              to="/mypage"
              className="bg-orange-500 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-orange-600 transition-colors"
            >
              마이페이지
            </Link>
          </div>

          {/* 모바일 메뉴 버튼 */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-orange-500"
            >
              <span className="sr-only">메뉴 열기</span>
              {!isMenuOpen ? (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              ) : (
                <svg
                  className="block h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* 모바일 메뉴 */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <Link
              to="/education"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-orange-500 hover:bg-gray-50"
            >
              교육 프로그램
            </Link>
            <Link
              to="/community"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-orange-500 hover:bg-gray-50"
            >
              커뮤니티
            </Link>
            <Link
              to="/support"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-orange-500 hover:bg-gray-50"
            >
              고객 지원
            </Link>
            <Link
              to="/login"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-orange-500 hover:bg-gray-50"
            >
              로그인
            </Link>
            <Link
              to="/mypage"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-600 hover:text-orange-500 hover:bg-gray-50"
            >
              마이페이지
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
